import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './TUIKit/TUIComponents/assets/icon/close_24.png'


const _withScopeId = n => (_pushScopeId("data-v-bd19aebe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-TUIKit-main" }
const _hoisted_2 = { class: "message-title-top" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "最近联系人", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "closeImg",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = ["v-show"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TUIConversation = _resolveComponent("TUIConversation")!
  const _component_TUIChat = _resolveComponent("TUIChat")!
  const _component_TUICallKit = _resolveComponent("TUICallKit")!

  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", {
      class: _normalizeClass(_ctx.env?.isH5 ? 'conversation-h5' : 'conversation')
    }, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closeTxChat && _ctx.closeTxChat(...args)))
        }, _hoisted_5)
      ]),
      _createVNode(_component_TUIConversation, { onCurrent: _ctx.handleCurrentConversation }, null, 8, ["onCurrent"])
    ], 2), [
      [_vShow, !_ctx.env?.isH5 || _ctx.currentModel === 'conversation']
    ]),
    _withDirectives(_createElementVNode("div", {
      "v-show": _ctx.showTUIChat,
      class: "chat"
    }, [
      _createVNode(_component_TUIChat)
    ], 8, _hoisted_6), [
      [_vShow, !_ctx.env?.isH5 || _ctx.currentModel === 'message']
    ]),
    _createVNode(_component_TUICallKit, {
      class: _normalizeClass(
        !_ctx.showCallMini ? 'callkit-drag-container' : 'callkit-drag-container-mini'
      ),
      allowedMinimized: true,
      allowedFullScreen: false,
      beforeCalling: _ctx.beforeCalling,
      afterCalling: _ctx.afterCalling,
      onMinimized: _ctx.onMinimized,
      onMessageSentByMe: _ctx.onMessageSentByMe
    }, null, 8, ["class", "beforeCalling", "afterCalling", "onMinimized", "onMessageSentByMe"])
  ], 512)), [
    [_vShow, true]
  ])
}